
import { useNavigate } from 'react-router-dom';
import { Bell, MapPin, TrendingUp, Crown, Power } from 'lucide-react';
import React, { useEffect, useState } from 'react';

const WorkerHero = ({
  ProfileImage,
  fullName,
  greeting,
  emoji,
  jobsDone,
  address,
  availablity,
  handleAvailablityToggle,
  availabilityLoading,
   unreadCount
}) => {
  const navigate = useNavigate();
  const [currentLocation, setCurrentLocation] = useState("Your Location");


useEffect(() => {

  if (!navigator.geolocation) {
    setCurrentLocation("Location unavailable");
    return;
  }


  navigator.geolocation.getCurrentPosition(
    async (position) => {

      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      try {

        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
        );

        const data = await response.json();


        const city =
          data.address.city ||
          data.address.town ||
          data.address.village ||
          "";


        const country = data.address.country || "";


        setCurrentLocation(`${city}, ${country}`);


      } catch (error) {

        console.log(error);
        setCurrentLocation("Location unavailable");

      }

    },

    (error) => {
      console.log(error);
      setCurrentLocation("Allow Location");
    }

  );

}, []);

  return (
    <div className="wh-hero">
      {/* Top row */}
      <div className="wh-hero__toprow">
        <div className="wh-hero__avatar" onClick={() => navigate('/worker-profile')}>
          {ProfileImage ? (
            <img
              src={ProfileImage}
              alt="Profile"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />
          ) : (
            <span>
              {fullName
                ? fullName
                  .split(' ')
                  .map(word => word.charAt(0))
                  .join('')
                  .toUpperCase()
                : 'U'}
            </span>
          )}
        </div>
        <div className="wh-hero__greeting">
          <span className="wh-hero__good">{greeting} {emoji}</span>
          <span className="wh-hero__name">
            {fullName}
          </span>
        </div>
       <button 
  className="wh-hero__bell" 
  onClick={() => navigate('/worker-notifications')}
>
  <Bell size={20} />

  {unreadCount > 0 && (
    <span className="wh-hero__notification-count">
      {unreadCount > 99 ? "99+" : unreadCount}
    </span>
  )}

</button>
      </div>

      {/* Earnings card inside hero */}
      <div className="wh-hero__card">
        <div className="wh-hero__card-left">
          <span className="wh-hero__card-week">
            <TrendingUp size={13} /> This Week
          </span>
          <span className="wh-hero__card-amount">$8,500</span>
          <span className="wh-hero__card-jobs">{jobsDone} jobs completed</span>
        </div>
        {/* <div className="wh-hero__card-right">
          <div className="wh-hero__badge">
            <Crown size={22}/>
            <span>Get Pro</span>
          </div>
        </div> */}
        <div className="wh-hero__card-right">
          <div
            className="wh-hero__badge"
            onClick={() => navigate('/workersubscription')}
          >
            <Crown
              size={22}
              style={{
                color: "#FFC107",
                filter: "drop-shadow(0 0 4px rgba(255,193,7,0.6))"
              }}
            />
            <span>Get Pro</span>
          </div>
        </div>
      </div>

      {/* Location & Activity Toggle */}
      <div className="wh-hero__bottom">
      <div className="wh-hero__location">
  <MapPin size={13} /> {currentLocation}
</div>

        {/* Activity Toggle Button */}
        <button
          className={`wh-availablity-toggle ${availablity ? 'wh-availablity-toggle--available' : ''
            }`}
          onClick={handleAvailablityToggle}
          disabled={availabilityLoading}
        >
          {availabilityLoading ? (
            <>
              <span className="wh-btn-spinner"></span>
              <span>Updating...</span>
            </>
          ) : (
            <>
              <Power size={14} />
              <span>{availablity ? 'Available' : 'Unavailable'}</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default WorkerHero;